module.exports = __webpack_public_path__ + "static/media/chatUs.8cc9351c.png";